import { SourceTable } from "../../graphql/types";
import { ProbeStatus } from "../ProbeStatus";
import { StatusTd, TableRow } from "../ui/muiTables";

const DownloadBundleRow = ({ downloadBundle }: { downloadBundle: SourceTable }) => (
  <TableRow>
    <td colSpan={6}>
      <span className="project">
        {downloadBundle.project} - {downloadBundle.name}
      </span>
    </td>
    <StatusTd>
      <ProbeStatus sourceBundle={downloadBundle.bundle} />
    </StatusTd>
  </TableRow>
);

export { DownloadBundleRow };
